<loading [isLoading]="isLoading" [success]="loadingSuccess"></loading>

@if (!isLoading && loadingSuccess) {
    <!-- Edit Form -->
    <form [formGroup]="postForm" (submit)="onSubmit()" class="flex flex-col gap-2" [ngClass]="{ 'hidden' : showPreview }">
        <div class="font-bold text-sm">
            Title
        </div>
        <input formControlName="title" type="text" class="p-1 text-sm font-mono bg-slate-50 rounded-sm shadow-sm disabled:bg-slate-100">
        <div class="font-bold text-sm">
            Body
        </div>
        <textarea formControlName="body" rows="16" class="p-1 text-sm font-mono bg-slate-50 rounded-sm shadow-sm disabled:bg-slate-100"></textarea>
        <div class="flex flex-row gap-4 justify-end">
            <div (click)="onTogglePreview()" class="p-1 text-sm text-slate-600 hover:text-ponder-bright hover:cursor-pointer">
                Preview
            </div>
            <button 
                (click)="onCancelClicked()" 
                class="w-[12ch] text-sm p-1 bg-slate-50 rounded-sm shadow-sm hover:text-ponder-link hover:stroke-ponder-link hover:cursor-pointer border border-transparent hover:border-ponder-link disabled:text-slate-500 disabled:bg-slate-100 disabled:hover:text-slate-500 disabled:hover:cursor-default disabled:hover:border-transparent"
                [disabled]="isProcessing">
                Cancel
            </button>
            <button 
                class="w-[12ch] text-sm p-1 bg-slate-50 rounded-sm shadow-sm hover:text-ponder-link hover:stroke-ponder-link hover:cursor-pointer border border-transparent hover:border-ponder-link disabled:text-slate-500 disabled:bg-slate-100 disabled:hover:text-slate-500 disabled:hover:cursor-default disabled:hover:border-transparent" 
                [disabled]="!canSubmit()">
                @if (isProcessing) {
                    <busy-spin [small]="true"></busy-spin>
                } @else {
                    @if (post) {
                        Update 
                    } @else {
                        Submit
                    }
                }
            </button>
        </div>
    </form>
    <!-- Preview -->
    <div class="flex flex-col gap-2 mb-12 max-w-full" [ngClass]="{ 'hidden' : !showPreview }">
        <news-post [title]="titlePreview" [content]="bodyPreview" [authorUsername]="authorUsername" [createdAt]="postCreatedDate" [modifiedAt]="postModifiedDate" class="text-sm overflow-clip"></news-post>
        <div class="flex flex-row gap-4 justify-end">
            <div (click)="onTogglePreview()" class="p-1 text-sm text-slate-600 hover:text-ponder-bright hover:cursor-pointer">
                Edit
            </div>
            <button 
                (click)="onCancelClicked()" 
                class="w-[12ch] text-sm p-1 bg-slate-50 rounded-sm shadow-sm hover:text-ponder-link hover:stroke-ponder-link hover:cursor-pointer border border-transparent hover:border-ponder-link disabled:text-slate-500 disabled:bg-slate-100 disabled:hover:text-slate-500 disabled:hover:cursor-default disabled:hover:border-transparent"
                [disabled]="isProcessing">
                Cancel
            </button>
            <button 
                class="w-[12ch] text-sm p-1 bg-slate-50 rounded-sm shadow-sm hover:text-ponder-link hover:stroke-ponder-link hover:cursor-pointer border border-transparent hover:border-ponder-link disabled:text-slate-500 disabled:bg-slate-100 disabled:hover:text-slate-500 disabled:hover:cursor-default disabled:hover:border-transparent" 
                [disabled]="!canSubmit()">
                @if (isProcessing) {
                    <busy-spin [small]="true"></busy-spin>
                } @else {
                    @if (post) {
                        Update 
                    } @else {
                        Submit
                    }
                }
            </button>
        </div>
    </div>
}